import { EventEmitter } from "events";

import Dispatcher from "./dispatcher";
import Constants from "./constants";
import getSidebarNavItems from "../data/sidebar-nav-items";
import getMemberSidebarNavItems from "../data/member-sidebar-nav-items"
import getAlacartSidebarNavItems from "../data/alacarte-sidebar-nav-item"
import getAdminSidebarNavItems from "../data/admin-sidebar-nav-item"
import getAdminSubSidebarNaveItems from "../data/admin-sidebar-sub-nav_items"

let _store = {
  menuVisible: false,
  navItems: getSidebarNavItems(),
  memberNavItems: getMemberSidebarNavItems(),
  alacarteNavItems: getAlacartSidebarNavItems(),
  adminNavItems: getAdminSidebarNavItems(),
  adminSubNavItems: getAdminSubSidebarNaveItems()
};

class Store extends EventEmitter {
  constructor() {
    super();

    this.registerToActions = this.registerToActions.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);

    Dispatcher.register(this.registerToActions.bind(this));
  }

  registerToActions({ actionType, payload }) {
    switch (actionType) {
      case Constants.TOGGLE_SIDEBAR:
        this.toggleSidebar();
        break;
      default:
    }
  }

  toggleSidebar() {
    _store.menuVisible = !_store.menuVisible;
    this.emit(Constants.CHANGE);
  }

  getMenuState() {
    return _store.menuVisible;
  }

  getSidebarItems() {
    return _store.navItems;
  }

  getMemberSidebarItems() {
    return _store.memberNavItems;
  }

  getAlacartSidebarNavItems() {
    return _store.alacarteNavItems;
  }

  getAdminSidebarNavItems() {
    return _store.adminNavItems;
  }

  getAdminSubSidebarNavItems() {
    return _store.adminSubNavItems;
  }

  addChangeListener(callback) {
    this.on(Constants.CHANGE, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(Constants.CHANGE, callback);
  }
}

export default new Store();
